import React, { useState } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import { useGetIdsConfig } from '@toktokdoctech/tokapi-client'

export default function UnavailabilityAlert() {
    const { data, isLoading } = useGetIdsConfig()
    const [isManuallyClosed, setIsManuallyClosed] = useState<boolean>(false)

    const handleClose = () => {
        setIsManuallyClosed(true)
    }

    if (!data || isLoading) return null
    const { isSystemUnavailable, isSystemBlocked, requiredExpertMessage } = data

    const title = isSystemBlocked ? 'Service totalement indisponible' : 'Service partiellement indisponible'

    return (
        <Dialog
            open={isSystemUnavailable && !isManuallyClosed}
            onClose={handleClose}
            disableEscapeKeyDown={isSystemBlocked}
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                {requiredExpertMessage.split('\n').map((item: string, index) => (
                    // eslint-disable-next-line react/no-array-index-key -- index will not change in this case
                    <span key={`unavailability-message-${index}`}>
                        {item}
                        <br />
                    </span>
                ))}
            </DialogContent>
            <DialogActions>
                {isSystemBlocked === false && (
                    <Button color="secondary" onClick={handleClose}>
                        Continuer
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    )
}
